exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.living-tab{border-top:0.09rem solid #ededed;border-bottom:0.09rem solid #ededed\n}\n.living-tab .van-tabs__wrap{height:0.95rem\n}\n.living-tab .van-tabs__nav{padding-bottom:0\n}\n.living-tab .van-tabs__line{display:none\n}\n.living-tab .van-tab__text{font-size:0.37rem;color:#666666;font-weight:500\n}\n.living-tab .van-tab--active .van-tab__text{font-size:0.48rem;color:#000000;font-weight:bold\n}\n", ""]);

// exports
